import React from 'react';
import { Link } from 'react-router-dom'
import  '../cambio.css';

function Home () {
    return (
        <section>
        <div class="text-center">
            <div class="row align-items-center bgbackg1 m">
                <div class="col-4 text-centr">
                    <div className="text-start">
                        <p class="h2 blanco">Sistema Integral ARBAL</p>
                        <h4 class="blanco">Plataforma de información y comunicación</h4>
                        <a target="_blank" href="https://arbal.com/gas/ua/r/aplicacion/aplicacion">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-03.png" alt="..."></img>
                        </a>
                    </div>
                </div>
                <div class="col-6">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739659/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-22.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                </div>
            </div>
        
            {/*
            <div class="row align-items-center">
                <div class="col-6">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739658/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-05.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                </div>
                <div class="col-4 text-centr2 text-start">
                <h2 class="h2">Cuestionario COVID-19</h2>
                <h4>Ayúdanos a mitigar contagios y estar más cerca de ti</h4>
                <h6 class="card-text fw-bold">Contesta este breve cuestionario diariamente</h6>
                <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/65da82e1-5f43-42e6-8592-69f04f4302a5">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739658/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-04.png" alt="..."></img>
                </a>
                </div>
            </div>
            */  }
        </div>
        
        <div class="text-center">
            <div class="row align-items-center bgbackg2 m">
                <div class="col-4 text-centr align-items-start">
                    <div className="text-start">
                    <p class="h2 blanco">Servicios</p>
                    <h4 class="blanco">Conoce nuestros servicios digitlizados</h4>   
                    <Link to="/siar">
                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-18.png" alt="..."></img>
                    </Link>
                    </div>
                </div>
                <div class="col-6">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739658/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-17.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                </div>
            </div>
        </div>

        <div class="text-center espacio">
                <div class="row align-items-center m">
                    <div class="col-6">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_375/v1610580279/ARBAL/SIAR/desayuno2019_2.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    </div>
                    <div class="col-4 text-start">
                    <h4 class="card-title">Administración de Riesgos BAL S.A. de C.V.</h4>
                    <h6 class="card-text">Fundada en 1999</h6>
                    <Link to="/construc">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-18.png" alt="..."></img>
                    </Link>
                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    </div>
                    </div>
                </div>
        </div>

        <div class="text-center espacio">
            <h2>Somos parte de Grupo BAL</h2>
            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619746877/ARBAL/SIAR/Nueva_versi%C3%B3n/empresas2.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
            <div class="text-centr2">
            <Link to="/construc">
                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_150/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-16.png" alt="..."></img>
            </Link>
            </div>
        </div>

    </section>
    )
}

export default Home